import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=606bbb95&scoped=true&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=606bbb95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bbb95",
  null
  
)

export default component.exports